import cx from 'classnames';
import React from 'react';

interface Props {
    children: React.ReactNode;
    inStartPosition?: boolean;
    mix?: string;
    scrollContent?: (scrollDistance: number) => void;
    scrollStep?: number;
}

export const CarouselPrevButton = ({ children, inStartPosition, mix, scrollContent, scrollStep }: Props) => {
    if (typeof scrollContent === 'undefined' || typeof scrollStep === 'undefined') {
        return null;
    }
    if (inStartPosition) {
        return null;
    }

    return (
        <div className={cx('carousel__prev-button', mix)} onClick={() => scrollContent(-1 * scrollStep)}>
            {children}
        </div>
    );
};
